import AudioWizard from './AudioWizard';
import connect from './connect';

const connectedWizard = connect(AudioWizard);
export default connectedWizard;
